<template>
  <el-dialog title="新增入住"
             :visible.sync="showModal"
             @close="handleCancel"
             :close-on-click-modal="false"
             width="40%">
    <el-card shadow="none">
      <el-col :span="24">
        <el-form :model="checkInData"
                 :rules="checkInRules"
                 ref="checkInForm"
                 label-width="125px"
                 class="checkin-form">

          <el-form-item label="IC卡:"
                        prop="medvalue">
            <el-input v-model.trim="checkInData.medvalue"
                      placeholder="卡号">
              <el-button slot="append"
                         @click="readIC()"
                         type="primary">读卡</el-button>
            </el-input>
            <span v-if="countDown">请读卡{{timer}}</span>
          </el-form-item>

          <el-form-item label="姓名:"
                        prop="guest">
            <el-input v-model.trim="checkInData.guest"
                      placeholder="姓名">
            </el-input>
          </el-form-item>

          <el-form-item label="所属区域:"
                        prop="area_id">
            <el-select v-model="checkInData.area_id"
                       placeholder="请选择所属区域"
                       @change="areaSelChange()">
              <el-option v-for="item in areaList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="设备权限:"
                        prop="lock_id">
            <el-select v-model="checkInData.lock_id"
                       placeholder="请选择设备">
              <el-option v-for="item in lockList"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <el-row :gutter="10">
            <el-form-item label="入住时间:"
                          prop="in_date">
              <el-col>
                <el-date-picker v-model="checkInData.in_date"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>

              </el-col>
              <el-col>
                <el-time-select v-model="checkInData.in_time"
                                :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '23:00'
                          }">
                </el-time-select>
              </el-col>
            </el-form-item>
          </el-row>

          <el-row :gutter="10">
            <el-form-item label="离店时间:"
                          prop="exp_date">
              <el-col>
                <el-date-picker v-model="checkInData.exp_date"
                                value-format="yyyy-MM-dd"
                                type="date"
                                placeholder="选择日期">
                </el-date-picker>

              </el-col>
              <el-col>
                <el-time-select v-model="checkInData.exp_time"
                                :picker-options="{
                            start: '00:00',
                            step: '01:00',
                            end: '23:00'
                          }">
                </el-time-select>
              </el-col>
            </el-form-item>
          </el-row>

          <el-form-item label="备注:"
                        prop="remark">
            <el-input v-model.trim="checkInData.remark"
                      placeholder="备注">
            </el-input>
          </el-form-item>

        </el-form>
      </el-col>
    </el-card>

    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleCancel">取 消</el-button>
      <el-button type="primary"
                 @click="handleConfirm('checkInForm')">确 定</el-button>
    </span>

  </el-dialog>
</template>

<script>
import fetch from '@/common/api'
import mediumApi from '@/common/medium'
export default {
  props: {
    isShow: {
      type: Boolean
    },
    data: {
      type: String
    },
    areaList: {}
  },
  data() {
    return {
      countDown: false,
      timer: 45,
      timeObj: null,
      randomNum: '',
      showModal: this.isShow,
      lockList: [],
      checkInData: {
        medvalue: '',
        guest: '',
        medtype: 'IC',
        area_id: '',
        lock_id: '',
        exp_date: '',
        exp_time: '',
        in_date: '',
        in_time: '',
        remark: ''
      },
      checkInRules: {
        medvalue: [{ required: true, message: '请输读卡或者输入卡号' }],
        area_id: [{ required: true, message: '请输选择所属区域' }],
        lock_id: [{ required: true, message: '请输选择设备' }],
        exp_date: [{ required: true, message: '请选择离店日期时间' }],
        in_date: [{ required: true, message: '请选择离店日期时间' }]
      }
    }
  },
  created() {
    this.getInfo()
    let yy = new Date().getFullYear()
    let mm =
      new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : new Date().getMonth() + 1
    let dd = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
    this.checkInData.in_date = yy + '-' + mm + '-' + dd

    let hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
    this.checkInData.in_time = hh + ':00'

    this.checkInData.exp_time = '12:00'
  },
  methods: {
    getInfo() {
      return 'girl'
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.checkInData.exp_date < this.checkInData.in_date) {
            this.$message.error('离店日期不能小于入住日期')
            return false
          } else if (this.checkInData.exp_date == this.checkInData.in_date) {
            if (this.checkInData.exp_time <= this.checkInData.in_time) {
              this.$message.error('离店时间不能小于或等于入住时间')
              return false
            }
          }

          fetch.addHotel({ ...this.checkInData }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.$message.success('操作成功')
                this.handleCancel('refresh')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        } else {
          return false
        }
      })
    },
    handleCancel(val) {
      this.$emit('handleClose', val)
    },
    //区域选择联动设备筛选
    areaSelChange() {
      this.lockList = []
      this.checkInData.lock_id = ''
      fetch
        .getLockList({ perPage: 0, currentPage: 0, type: 'old', area_id: this.checkInData.area_id })
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.lockList = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
    },
    //读取ic卡号
    readIC() {
      // loading倒计时提醒
      this.countDown = true
      this.timeObj = setInterval(() => {
        if (this.timer > 0) {
          this.timer--
        }
        if (this.timer === 0) {
          this.countDown = false
          clearInterval(this.timeObj)
        }
      }, 1000)
      this.randomNum = this.getRandomNum()
      mediumApi
        .getMediumInfo(
          {
            medType: 'ic',
            medTag: this.randomNum
          },
          { timeout: 45000 }
        )
        .then((data) => {
          data.procData(
            data.res,
            (data) => {
              if (data.medType === 'ic' && data.medTag === this.randomNum) {
                this.randomNum = ''
                this.checkInData.medvalue = data.medValue
                this.$message.success('读取成功')
              }
              this.countDown = false
              clearInterval(this.timeObj)
            },
            (err) => {
              this.countDown = false
              clearInterval(this.timeObj)
              this.$message.error(err)
            }
          )
        })
    },
    getRandomNum() {
      let randomNum = new Date().getTime() + ''
      let tmpLen = randomNum.length
      let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      let maxPos = $chars.length
      for (var i = 0; i < 32 - tmpLen; i++) {
        randomNum += $chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return randomNum
    }
  }
}
</script>

<style></style>
